module.exports = __webpack_public_path__ + "img/chess_chessblack3.59d09ff6.png";